import { gql, TypedDocumentNode } from '@apollo/client';
import { CardPaymentMerchantEnum } from '@libs/backend-common';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';

export type CardType = {
  id: string;
};

export type BogPaymentType = {
  fee: number;
};

export type GetCardsType = {
  id: string;
  cardMask?: string;
  cardExpiry?: string;
  cardPaymentMerchant: CardPaymentMerchantEnum;
  payments: BogPaymentType[];
};

type GetCardsArgs = {
  code?: string;
};
export type GetCardsResponse = {
  getCards: DefaultApiResponse<GetCardsType[]>;
};

export const getCardsQuery: TypedDocumentNode<
  GetCardsResponse,
  DefaultArg<GetCardsArgs>
> = gql`
  query GetCardsV2($record: OptionalAssetCodeRecord) {
    getCards: getCardsV2(record: $record) {
      id
      cardMask
      cardExpiry
      cardPaymentMerchant
      payments {
        fee
      }
    }
  }
`;
